module.exports = __webpack_public_path__ + "static/img/4areaA_2.1e3aafa.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/4areaA_2.png
// module id = 817
// module chunks = 1